// @ts-check
import { head } from 'ramda';
import { CertQualificationUtils } from "../../shared/certQualificationUtils";
import { 
  getWorkerCertifications, 
  getWorkerHealthCertifications,
} from '../../component-templates/certification-badge/utils';
import './resume.css';

class ResumeController {

  /* @ngInject */
  constructor (
    Users,
    Auth,
    ToastService,
    worker,
    $mdToast,
    $mdDialog,
    $state,
    $rootScope,
    inModal,
    application,
    $window,
    $q, 
    /** @type {import('../../shared/users').UsersModule} */
    UsersService
  ) {
    this.ToastService = ToastService
    this.Auth = Auth
    this.inModal = inModal || false
    this.worker = worker
    this.application = application
    this.$window = $window
    this.$q = $q
    if (this.application.workHistory) {
      this.workHistory = this.application.workHistory
    }
    if (this.application.applicationAnswers) {
      this.applicationAnswers = this.application.applicationAnswers
    }
    this.$state = $state
    this.worker.averageRating = head(this.worker.ratings.slice(-1))
    this.Users = Users
    this.$mdToast = $mdToast
    this.$mdDialog = $mdDialog
    this.$rootScope = $rootScope
    this.workHistoyLimit = 4

    this.UsersService = UsersService;
    this.userCertifications = []
    this.userCertifications.push(...getWorkerCertifications(this.worker))
    this.userCertifications.push(...getWorkerHealthCertifications(this.worker))
    this.Users.getCertificationsAdmin(this.worker.external_id).then(
      ([certifications, _drugScreenCertifications]) => {
        const filteredCertifications = CertQualificationUtils.filterLegacyCerts(certifications);
        this.userCertifications.push(
          ...CertQualificationUtils.formatCertifications(filteredCertifications)
        );
      }
    );

    this.UsersService.getUserQualifications(this.worker.external_id).then((qualifications) => {
      if (qualifications.length === 0) return;
      this.userCertifications.push(
        ...CertQualificationUtils.formatUserQualificationsToCerts(qualifications)
      );
    });

    this.worker.isVaccinated = (this.worker.covid_vaccination_response === "YES" || this.worker.covid_vaccination_date !== null)
  }

  close () {
    this.$mdDialog.hide()
  }

  directHire () {
    this.$state.go('app.jobCreate', {directlyInvitedWorkers: [this.worker] })
  }
}

export default ResumeController
